import type { RootState } from "app/store";

export const selectSnackbarInfo = (
  state: RootState
): {
  isOpen: boolean;
  level: "error" | "success" | "info";
  message: string;
  duration?: number;
} => {
  const { snackbarIsOpen, snackbarLevel, snackbarMessage, snackbarDuration } =
    state.ui;
  return {
    isOpen: snackbarIsOpen,
    level: snackbarLevel,
    message: snackbarMessage,
    duration: snackbarDuration,
  };
};
